module.exports = __webpack_public_path__ + "static/media/sendIcon.70f02c36.svg";